export default __webpack_public_path__ + "static/media/spinner.6e699242.svg";